import React, { lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Discover from './components/pages/Discover';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsOfService from './components/pages/TermsOfService';
import MobileCtaBar from './components/MobileCtaBar';

const Admin = lazy(() => import('./pages/Admin'));

function App() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin' || location.pathname.startsWith('/admin/');

  return (
    <>
      <Routes>
        <Route
          path="/admin"
          element={
            <Suspense fallback={<div style={{ minHeight: '100vh', background: '#0a0a0a' }} />}>
              <Admin />
            </Suspense>
          }
        />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="discover" element={<Discover />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<TermsOfService />} />
        </Route>
      </Routes>
      {!isAdmin && <MobileCtaBar />}
    </>
  );
}

export default App;
